import React from 'react';
import { IOption } from '../ExternalDashboardSensei/types';

export enum TabsKey {
  TASKS_FOR_ME = 'tasks',
  FIELD_SUPPORT = 'field_support'
}

export enum TableName {
  TASKS_FOR_ME = 'tasksForMe',
  FIELD_SUPPORT = 'fieldSupport'
}

export interface ITableTicket {
  referenceId: string;
  requestType: string;
  newUpdatesCount: number;
  isAcknowledgedByAssignee: boolean;
  status: string;
  label: string;
  customerName: string;
  loanAccountNumber: number;
  overdueAmount: {
    value: number;
  };
  requestedBy: {
    referenceId: string;
    name: string;
    userType: string;
  };
  assignedTo: {
    referenceId: string;
    name: string;
    userType: string;
  };
  createdAt: number;
}

export interface ITableData {
  pages?: {
    pageNo: number;
    totalPages: number;
    pageSize: number;
    totalElements: number;
  };
  data?: Array<ITableTicket>;
}

export interface IFilterSchema {
  key: string;
  multiSelect: boolean;
  isSearchEnabled: boolean;
  label: string;
  options: Array<IOption>;
}

export interface ICsaCoordination {
  tasksForMe: ITableData;
  requestedFieldSupport: ITableData;
  isLoading: boolean;
  fieldSupportFilterSchema: Record<string, IFilterSchema>;
  tasksForMeFilterScehma: Record<string, IFilterSchema>;
}

export interface ICloseTicketModal {
  toggleCloseTicketModal: () => void;
  status: string;
}

export interface INoActiveRequests {
  icon: React.ReactNode;
}

export interface ITableHeader {
  filterSchema: Record<string, IFilterSchema>;
  fetchData: () => void;
  tableName: string;
  clickstreamTableName: string;
}

export enum SortBy {
  CREATED_AT = 'createdAt',
  STATUS = 'status'
}

export interface IUpdateTicketStatusPayload {
  ticketReferenceId: string;
  status: string;
  comment?: string;
  address?: string;
}

export interface IAddCommentPayload {
  comment: string;
}

export interface IFetchRequestPayload {
  userId: string;
  loanId: string;
}

export interface ICreateTicket {
  supportRequestType: string;
  supportRequestCreatorType: string;
  loanAccountNumber: string;
  address: string;
  comment: string;
}

export interface IRequestForm {
  [key: string]: string;
}

export interface IUpdateTicketStatus {
  payload: IUpdateTicketStatusPayload;
  successCallbackFn?: () => void;
  finallyCallBackFn?: () => void;
  errorCallbackFn?: () => void;
}
